/**
 * Created by Mark on 20/01/2017.
 */


import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action from '../application-actions.js';


class CurriculumsServices {

    constructor(){

    }

    getCurriculumData(id){

        return ApplicationServices.call(Constants.GET_CURRICULUM_DATA , {curriculumUid:id}).then(function(response){
            return response
        });

    }

    getAllCurriculums(){
        return ApplicationServices.call(Constants.GET_ALL_CURRICULUMS , {}).then(function(response){
            Action.update(Constants.UPDATE_ALL_CURRICULUMS , response.curriculums);
        });
    }

}


export default new CurriculumsServices();